var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"bg-gray-50 py-8 pb-6 mt-6 mb-2 space-y-6"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }